// import { Box, Container, Text } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { Department } from "../../components/Departmens/Department";
// import { useTranslation } from "react-i18next"
// import useAuth from "../../hooks/useAuth"


export const Route = createFileRoute("/_layout/departments")({
    component: Department,
})